import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const ScrollToTop = ({ children, hardScroll }) => {
    const [locationKeys, setLocationKeys] = useState([]);
    const history = useHistory();

    useEffect(() => history.listen((loc) => {
        const scroll = () => {
            setTimeout(() => {
                const scrollEl = document.getElementById('scrollTop');
                if (scrollEl) {
                    scrollEl.scrollIntoView({ behavior: hardScroll ? undefined : 'smooth' });
                } else {
                    window.scrollTo({ top: 0, behavior: hardScroll ? undefined : 'smooth' }); // not supported by IE..
                }
            }, 0); // need timeout for iOs support
        };

        if (history.action === 'PUSH') {
            // Link event
            // console.log('link PUSH');
            scroll();
            setLocationKeys([loc.key]);
        } else if (history.action === 'REPLACE') {
            // Link event
            // console.log('link REPLACE');
            scroll();
        } else if (history.action === 'POP') {
            if (locationKeys[1] === loc.key) {
                // console.log('forward POP');
                // Forward event
                // eslint-disable-next-line no-unused-vars
                setLocationKeys(([_, ...keys]) => keys);
            } else {
                // console.log('backward POP');
                setLocationKeys(keys => [loc.key, ...keys]);
                // Back event
            }
        } else {
            // console.log('Unknown navigation', history.action);
        }
    }), [hardScroll, history, locationKeys]);

    return children;
};

ScrollToTop.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    hardScroll: PropTypes.bool,
};

ScrollToTop.defaultProps = {
    children: null,
    hardScroll: false,
};

export default ScrollToTop;
